export default __webpack_public_path__ + "static/pesdk2-714184f10d37a08c772b3819365f9432.png";